import { getApiErrorStatus } from "../../lib/api/apiError";
import { fetchWalletBalance, fetchWalletTopUpStatus } from "./paymentsService";
import { mapWallet } from "./paymentsMappers";
import { clearPendingTopUp } from "./topUpReturn";

const CREDIT_ATTEMPTS = 3;
const CREDIT_DELAY_MS = 1500;
const CONFIRM_ATTEMPTS = 5;
const CONFIRM_DELAY_MS = 2000;
const BALANCE_TOLERANCE = 0.005;

const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const hasCleared = (wallet, balanceBefore) =>
  balanceBefore == null || wallet.balance.value > balanceBefore + BALANCE_TOLERANCE;

export const isRetryableTopUpError = (error) => {
  const status = getApiErrorStatus(error);

  return status == null || status >= 500;
};

export const confirmTopUp = async (pending) => {
  try {
    let credited = null;

    for (let attempt = 0; attempt < CREDIT_ATTEMPTS; attempt += 1) {
      try {
        credited = mapWallet(await fetchWalletTopUpStatus(pending.reference));
        break;
      } catch (err) {
        if (!isRetryableTopUpError(err) || attempt === CREDIT_ATTEMPTS - 1) break;
        await wait(CREDIT_DELAY_MS);
      }
    }

    if (credited) return { confirmed: true, wallet: credited };

    for (let attempt = 0; attempt < CONFIRM_ATTEMPTS; attempt += 1) {
      try {
        const wallet = mapWallet(await fetchWalletBalance(pending.currencyCode));

        if (wallet) {
          credited = wallet;
          if (hasCleared(wallet, pending.balanceBefore)) break;
        }
      } catch {
        /* keep polling */
      }

      if (attempt < CONFIRM_ATTEMPTS - 1) await wait(CONFIRM_DELAY_MS);
    }

    return {
      confirmed: credited != null && hasCleared(credited, pending.balanceBefore),
      wallet: credited,
    };
  } finally {
    clearPendingTopUp();
  }
};
